import React from 'react';
import config from 'App/babel/config';
import './IntegrationIframe.scss';
import AppService from 'App/legacy/AppService';

type Props = {
	type: string;
	name: String;
	integrationId: number;
	objectId: number;
};

class IntegrationIframe extends React.Component<Props> {
	render() {
		const { type, name, integrationId, objectId } = this.props;

		const documentsOnCompanyStyling = `
			body {
				background-color: #ffffff;
			}
			.mainWrapper .grid {
				background-color: #ffffff;
			}
		`;

		let src = `${config.URL}${config.API}function/standardIntegrationIframe/${name}`;
		src += `?typeId=${type}&integrationId=${integrationId}&objectId=${objectId}&userId=${
			AppService.getSelf().id
		}`;

		return (
			<iframe
				onLoad={e => {
					const iframe = e.target as HTMLIFrameElement;
					if (!iframe.contentWindow) {
						return;
					}

					const style = document.createElement('style');
					style.textContent = documentsOnCompanyStyling;
					iframe.contentWindow.document.head.appendChild(style);
				}}
				className="IntegrationIframe"
				src={src}
			/>
		);
	}
}

export default IntegrationIframe;
